import { render, staticRenderFns } from "./header_black.vue?vue&type=template&id=0ec996b8&"
import script from "./header_black.vue?vue&type=script&lang=js&"
export * from "./header_black.vue?vue&type=script&lang=js&"
import style0 from "./header_black.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports